import { useQuery } from "@tanstack/react-query";
import { fetchAutoText } from "../api/fetchAutoText";

export const useAutoText = (statementId, enabled = true) => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["autoText", statementId],
    queryFn: () => fetchAutoText(statementId),
    enabled: !!statementId && enabled,
  });

  return { data: data?.result || [], error, isLoading, refetch };
};

